var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 100,
    viewBox: "0 0 236 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2.25L117.95 106.95L222.65 2.25C225.65 -0.75 230.65 -0.75 233.65 2.25C236.75 5.35 236.75 10.25 233.65 13.25L123.45 123.45C120.35 126.55 115.45 126.55 112.45 123.45L2.25 13.25C-0.75 10.15 -0.75 5.25 2.25 2.25C5.25 -0.75 10.15 -0.75 13.25 2.25Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.1e06122930d518a86d376dacea55c991.svg";
export { ForwardRef as ReactComponent };